<template>
  <esg-base-chart max-width="400px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart ref="chart"
                height="250"
                type="bar"
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    type: {
      type: String,
      required: true
    },
    colors: {
      type: Array,
      required: false,
    }
  },
  data() {
    return {
      loading: true,
      total: 0,
      categories: [],
      series: [],
      chartOptions: {
        colors: this.colors,
        chart: {
          type: 'bar',
          toolbar: {
            show: false
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            formatter: val => this.compactFormatNumber(val),
          },
          title: {
            text: '탄소 배출량 (tCO2)',
            style: {
              fontSize: 12,
              fontWeight: 'normal'
            }
          }
        },
        grid: {
          show: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: val => {
              const percentage = this.formatNumber(100 * val / this.total, 2);
              return `${this.formatNumber(val, 2)} tCO2e (${percentage}%)`
            }
          },
        },
        legend: {
          show: false
        }
      },
    }
  },
  created() {
    this.fetchData()
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let args = [{
          years: [year],
          scopes: [3],
          groupKeys: ['year', 'scope', 'category']
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }

        let list = JSON.parse(response.data.data)[0].data
        let categories = ({
          upstream: [1, 2, 3, 4, 5, 6, 7, 8],
          downstream: [9, 10, 11, 12, 13, 14, 15]
        })[this.type];

        // Calculate total emission
        this.setTotal(list);

        // Set series
        this.setSeries(list, categories);

        // Set categories
        this.setLabels(categories);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    setTotal(list) {
      this.total = list.map(row => row.values).reduce((a, b) => a + b, 0);
    },
    setSeries(list, categories) {
      let data = categories.map(category => {
        let index = list.findIndex(row => row.category === category)
        return index >= 0 ? list[index].values : 0
      });

      // 현재 구현되지 않은 다운스트림에 대해 더미 데이터 추가
      if (this.type === 'downstream') {
        data = [100000, 0, 5000, 9000, 0, 9000, 18200];
      }

      this.series = [{ name: "배출량", data }];
    },
    setLabels(categories) {
      this.chartOptions.xaxis.categories = categories.map(cat => this.categoryLabel(cat));
    },
    categoryLabel(categoryIndex) {
      let category = this.$store.getters['ghg/categories'][categoryIndex - 1];
      return `${category.category}. ${category.title}`;
    }
  }
}
</script>
